export default "__VITE_ASSET__VqojwcFS__"